// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__2d80N","logo":"Header_logo__B59QK"};